export default {
    getters: {
        INLINED: 'config_inlined',
        CURRENCY_CODE: 'config_currency_code',
        CURRENCY_LOCALE: 'config_currency_locale',
        CONFIG_IS_LOADED: 'config_config_is_loaded',
        TRANSLATIONS_ARE_LOADED: 'config_translations_are_loaded',
        LOCALES: 'config_locales',
        CURRENT_LOCALE: 'config_current_locale',
        DEFAULT_LOCALE: 'config_default_locale',
        LOCALE_CONFIGS: 'config_local_configs',
        GOOGLE_MAPS_API_KEY: 'config_google_maps_api_key',
        GOOGLE_MAPS_DEFAULT_CENTER: 'config_google_maps_default_center',
        COUNTRY: 'config_country',
        LATEST_TERMS_VERSION: 'config_terms',
        LATEST_PRIVACY_VERSION: 'config_privacy',
        NOW: 'now',
    },
    mutations: {
        INLINED: 'config_inlined',
        CURRENCY_CODE: 'config_currency_code',
        CURRENCY_LOCALE: 'config_currency_locale',
        CONFIG_IS_LOADED: 'config_config_is_loaded',
        TRANSLATIONS_ARE_LOADED: 'config_translations_are_loaded',
        LOCALES: 'config_locales',
        CURRENT_LOCALE: 'config_current_locale',
        DEFAULT_LOCALE: 'config_default_locale',
        LOCALE_CONFIGS: 'config_local_configs',
        GOOGLE_MAPS_API_KEY: 'config_google_maps_api_key',
        GOOGLE_MAPS_DEFAULT_CENTER: 'config_google_maps_default_center',
        COUNTRY: 'config_country',
        LATEST_TERMS_VERSION: 'config_terms',
        LATEST_PRIVACY_VERSION: 'config_privacy',
        START_TIMER: 'start_timer',
        STOP_TIMER: 'stop_timer',
        SET_CONFIG_CACHE: 'set_config_cache',
        SET_TRANSLATIONS_CACHE: 'set_translations_cache',
        CLEAR_TRANSLATIONS_CACHE: 'clear_translations_cache',
    },
    actions: {
        INIT: 'initialize',
        SET_INLINED: 'config_set_inlined',
        START_TIMER: 'start_timer',
        STOP_TIMER: 'stop_timer',
        LOAD_CONFIGS: 'config_load_configs',
        POPULATE_CONFIGS: 'config_populate_configs',
        LOAD_TRANSLATIONS: 'config_load_translations',
    },
}
